<template>
<div id="slideTop">
  <aside>
    <div class="slide_top">
      <!-- バナー -->
      <ul class="slider-wrapper">
        <li class="slide-item">
          <h2>ドゥーマンズおすすめ品</h2>
        </li>
        <li class="slide-item">
          <h2>What's NEW</h2>
        </li>
        <li class="slide-item">
          <h2>セール開催中</h2>
        </li>
      </ul>
    </div>
  </aside>
</div>
</template>
<script>
export default {
  name: 'dd-slideTop'
}
</script>
<style src="../../css/unit/unit.scss"  lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/components/unit/SlideTop.vue